import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// 유휴 세션 만료 경고 다이얼로그. 남은 시간을 초 단위로 보여주고 연장/로그아웃을 선택하게 한다.

const SessionTimeoutDialog = ({ open, remainingMs, onExtend, onLogout }) => {
  const seconds = Math.max(0, Math.ceil(remainingMs / 1000));

  return (
    <Dialog open={open} onClose={onExtend} maxWidth="xs" fullWidth>
      <DialogTitle>세션이 곧 만료됩니다</DialogTitle>
      <DialogContent>
        <DialogContentText>
          장시간 활동이 없어 <b>{seconds}초</b> 후 자동으로 로그아웃됩니다. 계속 사용하시려면 세션을 연장해주세요.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          로그아웃
        </Button>
        <Button onClick={onExtend} variant="contained" autoFocus>
          세션 연장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SessionTimeoutDialog.propTypes = {
  open: PropTypes.bool,
  remainingMs: PropTypes.number,
  onExtend: PropTypes.func,
  onLogout: PropTypes.func
};

export default SessionTimeoutDialog;
